module.exports = __webpack_public_path__ + "img/113.be3edd83.jpg";